import type { ProviderSelectionSourcePath } from "@src/constants";
import { APP_ROUTES } from "@src/constants";
import { useApplicationContext } from "@src/context/ApplicationContext";
import type { FC, ReactNode } from "react";
import { Fragment } from "react";
import { UTMNavigate } from "../UTMNavigate";

interface ProtectedRouteProps {
  children: ReactNode;
  expectedRoute: string; // The route that must be completed to access this page
  expectedRouteByProviderSelectionSource?: Partial<Record<ProviderSelectionSourcePath, string>>;
}

export const ProtectedRoute: FC<ProtectedRouteProps> = ({
  children,
  expectedRoute,
  expectedRouteByProviderSelectionSource,
}) => {
  const { completedRoutes, data } = useApplicationContext();
  const originSpecificExpectedRoute =
    data.providerSelectionSource &&
    expectedRouteByProviderSelectionSource?.[data.providerSelectionSource];
  const effectiveExpectedRoute = originSpecificExpectedRoute || expectedRoute;

  // Define the order of routes to check for the last completed route
  const routeOrder = [
    APP_ROUTES.GET_STARTED,
    APP_ROUTES.FIND_PROVIDER,
    APP_ROUTES.PROVIDER_PROFILE,
    APP_ROUTES.PATIENT_INFORMATION,
  ];

  // Find the first incomplete route in the specified order
  const firstIncompleteRoute = routeOrder.find((route) => {
    return !completedRoutes[route];
  });

  // Redirect to the first incomplete route if the expected route is not completed
  if (!completedRoutes[effectiveExpectedRoute] && firstIncompleteRoute) {
    return <UTMNavigate to={firstIncompleteRoute} />;
  }
  return <Fragment>{children}</Fragment>;
};
